import { Route, Routes } from 'react-router-dom'
import AccountDashboard from '../pages/account/dashboard/page'
import FavoritesPage from '../pages/account/favoris/page'
import OrdersPage from '../pages/account/mes-commandes/page'
import OrderDetailPage from '../pages/account/mes-commandes/details'
import ProfilePage from '../pages/account/profil/page'
import AccountLayout from '../layouts/AccountLayout'
import MainLayout from '../layouts/MainLayout'


export default function AccountNav() {
    return (
      <MainLayout>
          <AccountLayout>
            <Routes>
                <Route path="/" element={<AccountDashboard />} />
                <Route path="/favoris" element={<FavoritesPage />} />
                <Route path="/mes-commandes" element={<OrdersPage />} />
                <Route path="/mes-commandes/:id" element={<OrderDetailPage />} />
                <Route path="/profil" element={<ProfilePage />} />

            </Routes>
        </AccountLayout>
      </MainLayout>
    )
}
